import React from 'react';
import './AboutUs.css';

const AboutUs: React.FC = () => {
  return (
    <div className="about-us-page">
      <div className="container">
        <div className="page-title">
          <h1>About UPM Traders</h1>
          <p>Ultimate Profit in Money - Professional Trading Solutions</p>
        </div>
        
        <div className="about-content">
          <h2>Our Mission</h2>
          <p>At UPM Traders, our mission is to empower traders with professional tools, education, and market insights to achieve financial success. We provide high-quality trading signals, comprehensive education, and access to regulated brokers for serious traders worldwide.</p>
          
          <h2>Our Story</h2>
          <p>Founded with the vision of making professional trading accessible to everyone, UPM Traders brings together experienced traders, analysts, and educators who are passionate about helping others succeed in the financial markets. Our team consists of professionals with years of experience across various financial markets including forex, commodities, indices, stocks, and cryptocurrencies.</p>
          
          <h2>What We Offer</h2>
          <p>Our comprehensive trading solutions include precise trading signals, educational resources for all levels of traders, webinar training sessions, and partnerships with regulated and trusted brokers. We focus on risk management and sustainable trading strategies to help our clients achieve long-term success.</p>
          
          <h2>Our Values</h2>
          <ul>
            <li><strong>Transparency:</strong> We believe in clear communication and honest market analysis</li>
            <li><strong>Excellence:</strong> We maintain the highest standards in our services and education</li>
            <li><strong>Integrity:</strong> We operate with the utmost professionalism and ethical standards</li>
            <li><strong>Innovation:</strong> We continuously improve our tools and strategies to stay ahead of the market</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;